<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <Settings
        v-bind:region="'left'"
        class="template-settings"
        v-bind:title="resource('TemplateSettings_Settings_Title')"
    >
        <template v-slot:body
        >
            <div class="row">
                <div class="col-12">
                    <label>{{resource('TemplateSettings_Name_Label')}}</label>
                </div>
                <div class="col-12 mb-2">
                    <RenamableProperty
                        v-bind:name="name"
                        v-bind:inputClasses="'form-control'"
                        v-bind:max-length="50"
                        v-on:rename-property="$emit('rename-template', $event)"
                    />
                </div>

                <div class="col-12">
                    <label>{{resource('TemplateSettings_Modified_Label')}}</label>
                </div>
                <div class="col-12 mb-2">
                    {{modified}}
                </div>

                <div class="col-12">
                    <label>{{resource('TemplateSettings_Subject_Label')}}</label>
                </div>
                <div class="col-12 mb-2">
                    <RenamableProperty
                            v-bind:name="subject"
                            v-bind:inputClasses="'form-control'"
                            v-bind:max-length="250"
                            v-on:rename-property="$emit('rename-subject', $event)"
                    />
                </div>

                <div class="col-12">
                    <label>{{ resource('TemplateSettings_Sender_Label') }}</label>
                </div>
                <div class="col-12 mb-2">
                    <RenamableProperty
                            v-bind:name="sender || ''"
                            v-bind:inputClasses="'form-control'"
                            v-bind:max-length="150"
                            v-on:rename-property="$emit('rename-sender', $event)"
                    />
                </div>

                <div class="col-12">
                    <label>{{ resource('TemplateSettings_SenderName_Label') }}</label>
                </div>
                <div class="col-12 mb-2">
                    <RenamableProperty
                            v-bind:name="senderName || ''"
                            v-bind:inputClasses="'form-control'"
                            v-bind:max-length="150"
                            v-on:rename-property="$emit('rename-sender-name', $event)"
                    />
                </div>
                
                <div class="col-12 mb-2" v-if="canEditCustomCss">
                    <SettingsTextArea
                        v-bind:value="customCss"
                        v-bind:tooltip="resource('TemplateSettings_CustomCss_Tooltip')"
                        v-bind:label="resource('TemplateSettings_CustomCss_Label')"
                        v-bind:rows="8"
                        @input="$emit('change-custom-css', $event)"
                    >
                        
                    </SettingsTextArea>
                </div>
                
               <div class="col-12 mb-2">
                    <SettingsDropdown
                        v-if="canPickParent"
                        v-model="newParentId"
                        v-bind:label="resource('TemplateSettings_ParentTemplate_Label')"
                        v-bind:options="templates"
                        textField="name"
                        valueField="id"
                    />
               </div>
            </div>
        </template>
    </Settings>
</template>

<script>
    import SecurityApi from "../../../../Util/security";
    
    import resourceMixin from "../../../../Util/Mixins/resources";
    
    import Settings from './Settings.vue';
    import RenamableProperty from '../../../../Components/Util/RenamableProperty.vue';
    import SettingsDropdown from './SettingsDropdown.vue';
    import SettingsTextArea from "./SettingsTextArea.vue";

    export default {
        name: "template-settings",
        mixins: [resourceMixin],
        components: {
            RenamableProperty,
            Settings,
            SettingsDropdown,
            SettingsTextArea
        },
        created(){
            const vm = this;

            //permission, grantType
            SecurityApi.validatePermission(
                SecurityApi.Permissions.EmvCustomCss,
                SecurityApi.PermissionGrantTypes.Write
            ).then(canWrite => vm.canEditCustomCss = canWrite);
        },
        watch: {
            newParentId(value) {
                this.$emit('set-parent', value);
            }
        },
        data() {
            return {
                newParentId: this.parentId,
                canEditCustomCss: false
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            subject: {
                type: String,
                required: true
            },
            sender: {
                type: String
            },
            senderName: { 
                type: String
            },
            customCss: {
                type: String,
            },
            modified: {
                type: String,
                required: true
            },
            templates: {
                type: Array,
                required: true
            },
            parentId: {
                type: String
            },
            canPickParent: {
                type: Boolean,
                required: true
            }
        }
    };
</script>
